export default __webpack_public_path__ + "static/media/Icons_Tick_Grey icon.81cd784d.svg";